const pathName = window.location.pathname;

export const browser = {
    pathName,
};